import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';

import HiwStepsDesktop from './HiwStepsDesktop';
import HiwStepsMobile from './HiwStepsMobile';

const HiwSteps = () => {
  const { isBiggerThanTablet } = useMediaQuery();
  return isBiggerThanTablet() ? <HiwStepsDesktop /> : <HiwStepsMobile />;
};

export default HiwSteps;
